module.exports = __webpack_public_path__ + "img/cooler_des_3.ee874150.jpg";